export default "/assets/images/wcf-v2.webp?a91d4187c6b2da70ee1ad155962ac4ca";